/**
 * สี/ค่าคงที่เฉพาะหน้า Dashboard ใหม่
 * ไม่แตะ theme กลางใน App.tsx (colorPrimary ของทั้งระบบเป็นน้ำเงิน #2777c8 และหน้าอื่นใช้อยู่)
 * ปุ่มส้มในหน้านี้จึง override เฉพาะจุด
 */
export const sd = {
  orange: "#F5871F",
  orangeSoft: "#FFF3E6",
  navy: "#16243D",
  navyTile: "#1E3050",
  navyBorder: "#2B3F63",
  blue: "#2777c8",
  blueSoft: "#EAF2FF",
  green: "#22A06B",
  greenSoft: "#E8F7F0",
  purple: "#7A5AF8",
  purpleSoft: "#F3EEFF",
  red: "#E5484D",
  grey: "#C7CDD6",
  ink: "#1F2937",
  muted: "#6B7280",
  subtle: "#9AA3AF",
  border: "#EEF0F4",
  page: "#F6F7FB",
  cardBg: "#FFFFFF",
  radius: 12,
  shadow: "0 1px 3px rgba(16,24,40,.06), 0 1px 2px rgba(16,24,40,.04)",
} as const;

/** สีของแต่ละ bucket ในโดนัท "สถานะออเดอร์" — ใช้ร่วมกันระหว่างวงกลมกับ legend */
export const ORDER_STATUS_COLORS = {
  awaiting_prep: sd.orange,
  shipping: sd.blue,
  delivered: sd.green,
  cancelled: sd.grey,
} as const;

export const ORDER_STATUS_LABELS = {
  awaiting_prep: "รอเตรียมสินค้า",
  shipping: "กำลังจัดส่ง",
  delivered: "ส่งสำเร็จ",
  cancelled: "ยกเลิก/คืนสินค้า",
} as const;
